// extracted by mini-css-extract-plugin
export var icon = "Search-module--icon--h9U-e";
export var searchBar = "Search-module--searchBar--Ht0cg";
export var searchBarOpen = "Search-module--searchBarOpen--NpIPI";
export var searchForm = "Search-module--searchForm--d50Mg";
export var whiteText = "Search-module--whiteText--lMdh0";